import type { QueryClient } from "@tanstack/react-query";

/** Cache-backed flag for "the backend is re-reading auto parameter values
 * from the freshly rendered image". Set when the refinement image event
 * arrives (before navigation) and cleared when the stream finishes, so the
 * refine page can show a syncing state across the navigation boundary. */
export const parameterResyncQueryKey = (imageId: string) =>
  ["parameter-resync", imageId] as const;

export function setParameterResyncPending(
  queryClient: QueryClient,
  imageId: string,
  pending: boolean,
): void {
  queryClient.setQueryData(parameterResyncQueryKey(imageId), pending);
}
